import _ from 'lodash';
import { createFsDocKey_alt } from '../../../../../global/firestoreData/appData/fsAppData';
import { matchCalcs } from '../../../helpers/match';
import { _matchLsTypes, matchStatusTypes } from '../SportsDataReducer';

const _removeProps = [
  '_itemKey',
  'parentKeys',
  'position',
  'combined',
]


const convertGsMatchToExistingFormat = (gsMatch, teams) => {

  const homeTeam = _.find(teams, { name: gsMatch.home }) || {};
  const awayTeam = _.find(teams, { name: gsMatch.away }) || {};

  const bothHaveKeys = homeTeam._itemKey && awayTeam._itemKey;
  const sameLevel = homeTeam.levels === awayTeam.levels;
  const sameSection = homeTeam.sections === awayTeam.sections;

  let matchLevels = _matchLsTypes.Non;
  let _matchCollectionKey = _matchLsTypes.Non;

  if (sameLevel && sameSection) {
    matchLevels = homeTeam.levels;
    _matchCollectionKey = homeTeam.levels;
  } else if (!bothHaveKeys) {
    matchLevels = _matchLsTypes.nonDistrict;
    _matchCollectionKey = _matchLsTypes.nonDistrict;
  } else if (sameLevel) {
    matchLevels = homeTeam.levels;
  }

  const matchSections = ((awayTeam.sections === homeTeam.sections) && (awayTeam.levels === homeTeam.levels))
    ? homeTeam.sections
    : _matchLsTypes.Non;

  const match = {
    home: {
      id: homeTeam._itemKey || gsMatch.home,
      name: homeTeam.name || gsMatch.home,
      levels: homeTeam.levels || _matchLsTypes.Non,
      sections: homeTeam.sections || _matchLsTypes.Non,
    },
    away: {
      id: awayTeam._itemKey || gsMatch.away,
      name: awayTeam.name || gsMatch.away,
      levels: awayTeam.levels || _matchLsTypes.Non,
      sections: awayTeam.sections || _matchLsTypes.Non,
    },
    startDate: gsMatch.startDate,
    startTime: '7:00 PM',
    levels: matchLevels ? matchLevels : _matchLsTypes.Non,
    sections: matchSections ? matchSections : _matchLsTypes.Non,
    _matchCollectionKey: _matchCollectionKey,
  };

  const homeScoreExists = gsMatch.homeScore !== undefined && gsMatch.homeScore !== null && gsMatch.homeScore !== '';
  const awayScoreExists = gsMatch.awayScore !== undefined && gsMatch.awayScore !== null && gsMatch.awayScore !== '';

  if (homeScoreExists && awayScoreExists) {
    match.results = {
      score: {
        home: Number(gsMatch.homeScore),
        away: Number(gsMatch.awayScore),
      },
    };
  }

  return match;
};

const createScoresObject = (obj) => {
  const scores = {};

  for (let i = 1; i <= 5; i++) {
    const homeKey = `home${i}`;
    const awayKey = `away${i}`;

    if (obj[homeKey] !== undefined || obj[awayKey] !== undefined) {
      scores[i] = {
        home: obj[homeKey],
        away: obj[awayKey],
      };
    }
  }

  return scores;
};

/**
 * 
 * @param {object} matches_gs 
 * @param {object} matches_db 
 * @param {object} teams 
 * @param {string} gameScoringType 
 * @returns matchUpdates
 */
const compareMatches = (mainDb, matches_gs, matches_db, teams, forPlayoffs, gameScoringType) => {

  // const updates = [];
  const matchUpdates = {};

  console.log('matches_gs', matches_gs)

  const dels = _.filter(matches_gs, { cancelled: 'TRUE' })
  console.log('dels', dels)
  // const getDuplicateMatches = (gsMatches) => {
  //   const grouped = _.groupBy(gsMatches, match => `${match.away}_${match.home}`);
  //   return _.pickBy(grouped, matches => matches.length > 1);
  // };

  // const groupedMatches = getDuplicateMatches(gsMatches)

  _.forEach(matches_gs, match_gs => {

    // the playoff google sheet may have a pending (winner/loser) as a name. Ignore that match
    if (!_.startsWith(match_gs.away, 'winner') && !_.startsWith(match_gs.away, 'loser')) {

      // the the match_db by finding the matching away and home names
      let match_db = _.find(matches_db, em =>
        _.get(em, 'home.name') === match_gs.home &&
        _.get(em, 'away.name') === match_gs.away
      );

      const match_dba = _.find(matches_db, em =>
        _.get(em, 'home.name') === match_gs.away &&
        _.get(em, 'away.name') === match_gs.home
      );

      const gsScoreHome = Number(match_gs.homeScore);
      const gsScoreAway = Number(match_gs.awayScore);

      // does it have a score
      const hasGsScore = match_gs.homeScore != null && match_gs.awayScore != null && !isNaN(gsScoreHome) && !isNaN(gsScoreAway);

      let isCancelled = match_gs.cancelled === 'TRUE' ? true : false
      const isRemoved = match_gs.remove === 'TRUE' ? true : false

      if (forPlayoffs && !match_db && match_dba) {
        match_db = _.cloneDeep(match_dba)
        match_db.away = _.cloneDeep(match_dba.home);
        match_db.home = _.cloneDeep(match_dba.away);
        console.log('match_dba', match_dba)
      }

      if (match_db) {

        // match has already been marked as cancelled
        if (isCancelled && match_db._isCancelled) { isCancelled = false }

        const { _itemKey, startDate } = match_db

        const emScoreHome = _.get(match_db, 'results.score.home');
        const emScoreAway = _.get(match_db, 'results.score.away');
        const emMatchStatus = _.get(match_db, 'matchStatus');

        const scoreIsNew = hasGsScore && _.isNil(emScoreHome) && _.isNil(emScoreAway);
        const scoreChanged = !scoreIsNew && hasGsScore && ((emScoreHome !== gsScoreHome) || (emScoreAway !== gsScoreAway));

        const matchStatusChanged = match_gs.matchStatus !== emMatchStatus
        const dateChanged = match_gs.startDate !== startDate;

        if (dateChanged) {
          console.log('dateChanged', match_db)
        }

        if (matchStatusChanged || dateChanged || isCancelled || isRemoved || ((scoreChanged || scoreIsNew))) {

          const mergedMatch = _.merge({}, match_db, {
            startDate: match_gs.startDate,
          });

          if (hasGsScore) {
            mergedMatch.results = {
              score: {
                home: gsScoreHome,
                away: gsScoreAway
              }
            }
          }

          const scores = createScoresObject(match_gs)

          if (!_.isEmpty(scores)) {
            mergedMatch.results.scores = scores
          }

          if (mergedMatch.startDate !== match_db.startDate) {
            mergedMatch._oldStartDate = match_db.startDate;
          }

          if (isCancelled) {
            mergedMatch._isCancelled = true
          }

          if (isRemoved) {
            mergedMatch._isRemoved = true
          }

          if (matchStatusChanged && match_gs.matchStatus) {
            mergedMatch.matchStatus = match_gs.matchStatus;
          }

          matchUpdates[_itemKey] = {
            ...mergedMatch,
            _matchChanges: {
              scoreChanged: scoreChanged,
              scoreIsNew: scoreIsNew,
              dateChanged: dateChanged,
              matchStatusChanged: matchStatusChanged,
              cancelled: isCancelled,
              removed: isRemoved,
            },
          }
        }
      } else {

        if (!isCancelled && !isRemoved) {
          const xxx = createFsDocKey_alt(mainDb)

          const transformedGsMatch = convertGsMatchToExistingFormat(match_gs, teams);
          transformedGsMatch._itemKey = xxx

          matchUpdates[xxx] = {
            ...transformedGsMatch,
            _matchChanges: {
              scoreChanged: false,
              scoreIsNew: false,
              dateChanged: false,
              matchStatusChanged: false,
              matchIsNew: true
            },
          }
        }

      }
    }
  });

  _.forEach(matchUpdates, (m) => {
    matchCalcs.calcVballMatch(m, gameScoringType)
  })

  return matchUpdates;
};




/**
 * 
 * @param {*} matches_db matches from the database
 * @param {*} matches_gs matches from the google sheet
 * @param {*} teams all the teams
 * @param {*} forPlayoffs 
 * @returns 
 */
export const getMatchUpdates = (mainDb, matches_info, matches_gs, teams, forPlayoffs, forRefresh, gameScoringType) => {

  const { matches, matches_playoffs } = matches_info ?? {}
  const matches_db = forPlayoffs ? matches_playoffs : matches

  const matchUpdates = compareMatches(mainDb, matches_gs, matches_db, teams, forPlayoffs, gameScoringType)

  console.log('matchUpdates', matchUpdates)

  matchCalcs.calcAllVballMatches(matchUpdates)

  const matchUpdates_data = {}
  const matchUpdates_grouped = groupByMatchStatusTypes(matchUpdates)
  createMatchUpdates_data(matchUpdates, matchUpdates_data, matchUpdates_grouped, forPlayoffs)

  const matchResultsInfo = {
    matchUpdates_data,
    matchUpdates_data_current: forPlayoffs ? matchUpdates_data?.['seasonPlayoff'] : matchUpdates_data?.['season'],
    matchUpdates_grouped,
    matchUpdates_grouped_current: forPlayoffs ? matchUpdates_grouped?.['seasonPlayoff'] : matchUpdates_grouped?.['season'],
    matchUpdates
  }

  return matchResultsInfo

}

export const createMatchUpdates_data = (matches, matchUpdates_data, matchUpdates_grouped, forPlayoffs) => {

  // 2 groupds: seasonPlayoff and season
  const _matches_season = _.mapKeys(
    _.groupBy(matches, 'isPlayoff'),
    (_, key) => (key === 'true' ? matchStatusTypes.seasonPlayoff : matchStatusTypes.season)
  );

  _.forEach(_matches_season, (ms, matchType) => {
    const updates = {}
    const _matches = matchType === matchStatusTypes.seasonPlayoff ? _.groupBy(ms, 'levels') : _.groupBy(ms, '_matchCollectionKey')
    _.forEach(_matches, (_levelMatches, levelKey) => {
      if (!updates[levelKey]) { updates[levelKey] = {} }
      _.forEach(_levelMatches, (levelMatch, matchKey) => {
        const { isPlayoff, _itemKey } = levelMatch
        const _matchPrefix = isPlayoff ? 'playoffMatches' : 'matches'
        if (!levelMatch.teams && levelMatch?.away?.id && levelMatch?.home?.id) {
          levelMatch.teams = [levelMatch.away.id, levelMatch.home.id]
        }
        updates[levelKey][_matchPrefix + '.' + _itemKey] = levelMatch
      })
    })
    matchUpdates_data[matchType] = updates
    if (matchUpdates_grouped) {
      matchUpdates_grouped[matchType] = _.values(ms)
    }
  })
}

export const createMatchLevelUpdate_data = () => {
  _.forEach(_matches, (_levelMatches, levelKey) => {
    if (!updates[levelKey]) { updates[levelKey] = {} }
    _.forEach(_levelMatches, (levelMatch, matchKey) => {
      const { isPlayoff, _itemKey } = levelMatch
      const _matchPrefix = isPlayoff ? 'playoffMatches' : 'matches'
      if (!levelMatch.teams && levelMatch?.away?.id && levelMatch?.home?.id) {
        levelMatch.teams = [levelMatch.away.id, levelMatch.home.id]
      }
      updates[levelKey][_matchPrefix + '.' + _itemKey] = levelMatch
    })
  })
}


const groupByMatchStatusTypes = (updatedMatches) => {
  return _.reduce(updatedMatches, (result, match) => {
    // Loop through each value in the _matchStatusTypes array
    _.forEach(match._matchStatusTypes, (status) => {
      if (status !== 'playoffs') {
        // Initialize the group if it doesn't exist
        if (!result[status]) {
          result[status] = [];
        }
        // Add the match to the appropriate group
        result[status].push(match);
      }
    });
    return result;
  }, {});
};

